"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
require("rxjs/add/observable/combineLatest");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var Subject_1 = require("rxjs/Subject");
/**
 *
 */
var SearchFilterComponent = /** @class */ (function () {
    function SearchFilterComponent() {
        this.isLoadedSubject = new ReplaySubject_1.ReplaySubject();
        this.ngUnsubscribe = new Subject_1.Subject();
        /**
             * Event to listen to get created filter.
             * @type {EventEmitter<object>}
             * @default
             */
        this.getSearchFilter = new core_1.EventEmitter();
    }
    SearchFilterComponent.prototype.isLoaded = function () {
        return this.isLoadedSubject.asObservable().takeUntil(this.ngUnsubscribe);
    };
    SearchFilterComponent.prototype.ngOnInit = function () {
        console.log("initing search filter component");
        this.isLoadedSubject.next(true);
    };
    SearchFilterComponent.prototype.ngOnDestroy = function () {
        console.log("destroying search filter component");
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    SearchFilterComponent.decorators = [
        { type: core_1.Component, args: [{
                    moduleId: module.id + '',
                    selector: 'sis-portfolio-search-filter',
                    styles: [require('./search-filter.component.css')],
                    template: require('./search-filter.component.html'),
                },] },
    ];
    /** @nocollapse */
    SearchFilterComponent.ctorParameters = function () { return []; };
    SearchFilterComponent.propDecorators = {
        "categorySystemName": [{ type: core_1.Input },],
        "getSearchFilter": [{ type: core_1.Output },],
    };
    /**
     *
     */
    SearchFilterComponent = __decorate([
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "\n                      <sis-portfolio-filter\n                          [categorySystemName]=\"'%{categorySystemName}'\"\n                          [filterFields]=\"%{filterFields}\"\n                          [filterKey]=\"'%{filterKey}'\"\n                          %{#filterWithData} [filterWithData]=\"%{filterWithData}\"%{/filterWithData}\n                          %{#getFilter} (getFilter)=\"%{getFilter}\"%{/getFilter}\n                          %{#filterWithDataChange} (filterWithDataChange)=\"%{filterWithDataChange}\"%{/filterWithDataChange}>\n                      </sis-portfolio-filter>\n                   ",
        })
    ], SearchFilterComponent);
    return SearchFilterComponent;
}());
exports.SearchFilterComponent = SearchFilterComponent;
//# sourceMappingURL=search-filter.component.js.map